import { render, staticRenderFns } from "./LanguageControl.vue?vue&type=template&id=95f80df8&lang=pug&"
import script from "./LanguageControl.vue?vue&type=script&lang=js&"
export * from "./LanguageControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports